import { render } from "./MessageManagement.vue?vue&type=template&id=416f1d60&scoped=true"
import script from "./MessageManagement.vue?vue&type=script&lang=js"
export * from "./MessageManagement.vue?vue&type=script&lang=js"

import "./MessageManagement.vue?vue&type=style&index=0&id=416f1d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416f1d60"]])

export default __exports__